var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMUbuntuCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 5000 2916",
    style: {
      enableBackground: "new 0 0 5000 2916"
    },
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#330066"
    },
    width: 5000,
    height: 2916
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "1370.828,2916 0,0 0,2916  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060721305892042081210000005027592635095889587_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015317268165911496230000013809895998711569811_",
    gradientUnits: "userSpaceOnUse",
    x1: 943.4734,
    y1: 2845.0896,
    x2: 414.1575,
    y2: -0.0274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF00"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.83,
      clipPath: "url(#SVGID_00000060721305892042081210000005027592635095889587_)",
      fill: "url(#SVGID_00000015317268165911496230000013809895998711569811_)"
    },
    width: 1370.828,
    height: 2916
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106148459797273435090000015039519227125289874_",
    points: "468.94,997.522 0,677.385 0,2916  1370.828,2916 3279.158,2916 954.628,1329.09  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072992861042264537960000013646657238967424954_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106148459797273435090000015039519227125289874_",
    style: {
      overflow: "visible"
    }
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 677.385,
    width: 3279.158,
    height: 2238.615
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 677.385,
    width: 3279.158,
    height: 2238.615,
    id: "SVGID_00000150797041113468633240000006665227655354098305_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054250917146436645620000009981111721620895678_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.5746,
    y1: 4938.4487,
    x2: -3157.7275,
    y2: 2921.604,
    gradientTransform: "matrix(1 0 0 1 2886.4673 -2283.864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 677.385,
    style: {
      clipPath: "url(#SVGID_00000072992861042264537960000013646657238967424954_)",
      fill: "url(#SVGID_00000054250917146436645620000009981111721620895678_)"
    },
    width: 3279.158,
    height: 2238.615
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033362919865538369180000007000627954788034489_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.2214,
    y1: 1796.6923,
    x2: 3279.1814,
    y2: 1796.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF00"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 677.385,
    style: {
      clipPath: "url(#SVGID_00000072992861042264537960000013646657238967424954_)",
      mask: "url(#SVGID_00000150797041113468633240000006665227655354098305_)",
      fill: "url(#SVGID_00000033362919865538369180000007000627954788034489_)"
    },
    width: 3279.158,
    height: 2238.615
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067914842729802531850000003527069709035692475_",
    points: "0,2916 769.492,1636.846 1754.162,0 0,0  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013900731352206060350000012864841724136981639_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067914842729802531850000003527069709035692475_",
    style: {
      overflow: "visible"
    }
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000016760318684266068260000011568588251643831942_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1754.162,
    height: 2916
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1754.162,
    height: 2916,
    id: "SVGID_00000129910106517338243100000002416869400570916761_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000016760318684266068260000011568588251643831942_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018228342755030198100000013358506230691238283_",
    gradientUnits: "userSpaceOnUse",
    x1: -1183.3381,
    y1: 2983.6555,
    x2: -4025.6023,
    y2: 5592.4951,
    gradientTransform: "matrix(1 0 0 1 2886.4673 -2283.864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: -0.001,
    style: {
      clipPath: "url(#SVGID_00000013900731352206060350000012864841724136981639_)",
      fill: "url(#SVGID_00000018228342755030198100000013358506230691238283_)"
    },
    width: 1754.162,
    height: 2916.001
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041273735055857688240000012428874297688133055_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.0204,
    y1: 2476.0146,
    x2: 1743.1053,
    y2: 200.4405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF00"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000013900731352206060350000012864841724136981639_)",
      mask: "url(#SVGID_00000129910106517338243100000002416869400570916761_)",
      fill: "url(#SVGID_00000041273735055857688240000012428874297688133055_)"
    },
    width: 1754.162,
    height: 2916
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080911466071800803100000003034809301427806642_",
    points: "1155.191,995.688 206.943,440.209  468.94,997.522 954.628,1329.09 3279.158,2916 4433.317,2916  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001623237408369406760000003160274113240048773_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080911466071800803100000003034809301427806642_",
    style: {
      overflow: "visible"
    }
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065788595121723815900000014291741850513511854_",
    filterUnits: "userSpaceOnUse",
    x: 206.943,
    y: 440.209,
    width: 4226.374,
    height: 2475.791
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 206.943,
    y: 440.209,
    width: 4226.374,
    height: 2475.791,
    id: "SVGID_00000053532594936547289840000008367611040973066391_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000065788595121723815900000014291741850513511854_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005232318595565525020000014610674921347712175_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.8162,
    y1: 5144.6953,
    x2: -2999.5837,
    y2: 2894.5166,
    gradientTransform: "matrix(1 0 0 1 2923.8787 -2283.864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.943,
    y: 440.209,
    style: {
      clipPath: "url(#SVGID_00000001623237408369406760000003160274113240048773_)",
      fill: "url(#SVGID_00000005232318595565525020000014610674921347712175_)"
    },
    width: 4226.375,
    height: 2475.791
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071524118399560577160000001101482682381855388_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.9434,
    y1: 1678.1045,
    x2: 4433.3174,
    y2: 1678.1045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.943,
    y: 440.209,
    style: {
      clipPath: "url(#SVGID_00000001623237408369406760000003160274113240048773_)",
      mask: "url(#SVGID_00000053532594936547289840000008367611040973066391_)",
      fill: "url(#SVGID_00000071524118399560577160000001101482682381855388_)"
    },
    width: 4226.374,
    height: 2475.791
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMUbuntuCardBg);
export default __webpack_public_path__ + "static/media/mUbuntuCardBG.7f584043088d9982b036f4363e0308ae.svg";
export { ForwardRef as ReactComponent };